import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Curation } from '../types/curation';
import { SupportedCurrency } from '../utils/currencyUtils';
import CurationRestaurantItem from './CurationRestaurantItem';
import useTranslation from '../hooks/useTranslation';

interface CurationCardProps {
  curation: Curation;
  currency: SupportedCurrency;
}

const CurationCard: React.FC<CurationCardProps> = ({ curation, currency }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  // 카테고리별 제목 가져오기 (임시로 코드값 사용)
  const getCategoryTitle = (category: string): string => {
    const translationKey = `curation.category.${category}`;
    return t(translationKey) || category;
  };
  
  const categoryTitle = getCategoryTitle(curation.category);

  // 더보기 버튼 클릭 핸들러
  const handleViewMore = () => {
    navigate(`/curations/${curation.category}`);
  };

  return (
    <div className="mb-6">
      {/* 카테고리 제목 */}
      <div className="mb-4 px-4 flex justify-between items-center">
        <h3 className="text-xl font-bold text-gray-900 text-left">
          {categoryTitle}
        </h3>
        
        {/* 더보기 버튼 (UI만, 기능 없음) */}
        <button 
          className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
          onClick={handleViewMore}
        >
          {/* <span className="text-sm mr-1">{t('curation.viewMore')}</span> */}
          <svg 
            className="w-4 h-4" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9 5l7 7-7 7" 
            />
          </svg>
        </button>
      </div>
      
      {/* 레스토랑 목록 가로 스크롤 */}
      <div className="relative">
        <div 
          className="flex overflow-x-auto scrollbar-hide pb-4 px-4 space-x-4" 
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {curation.stores.map((store) => (
            <CurationRestaurantItem 
              key={store.id} 
              store={store} 
              currency={currency}
              curationName={categoryTitle}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CurationCard; 